<template>
    <div :class="['cookies', { 'is-active': isActive }]">
        <div class="wrapper flex flex-center">
            <div class="cookies-body">
                Szanowny Kliencie, w celu zapewnienia najlepszej jakości usług
                oraz zagwarantowania najlepszych promocji wykorzystujemy pliki
                cookies. Jeśli zgadzasz się przekazywać nam te informacje
                prosimy o kliknięcie <strong>„Zgadzam się”</strong>.
                <a
                    href="https://makrodlahandlu.pl/files/polityka-prywatnosci-makro.pdf"
                    target="_blank"
                    rel="noreferrer"
                >
                    Polityka prywatności >>
                </a>
            </div>
            <div class="cookies-action">
                <a
                    class="cp text-upper"
                    @click="onAllowCookies"
                >
                    Zgadzam się
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false,
        };
    },
    mounted() {
        const cookiesAllowed = window.localStorage.getItem("cookiesAllowed");

        if (!cookiesAllowed) {
            setTimeout(() => {
                this.isActive = true;
            }, 1000);
        }
    },
    methods: {
        onAllowCookies() {
            window.localStorage.setItem("cookiesAllowed", '1');
            this.$store.dispatch('cookies/setIsAllowed', 1)
            this.isActive = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.cookies {
    transition: all 0.15s ease-out;
    transform: translateY(10px);
    position: fixed;
    pointer-events: none;
    color: #fff;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100001;
    opacity: 0;

    &.is-active {
        transform: none;
        pointer-events: all;
        opacity: 1;
    }

    &-body {
        padding-top: 30px;
        padding-bottom: 30px;
        font-size: 1.5rem;
        line-height: 2rem;
        font-weight: 400;

        a {
            color: #ffe800;
        }
    }

    &-action {
        margin-left: 50px;

        a {
            background-color: #ffe800;
            color: #003c7b;
            white-space: nowrap;
            display: inline-block;
            font-size: 1.5rem;
            line-height: 2rem;
            font-weight: 700;
            padding: 10px 15px;
            border-radius: 3px;

            &:hover {
                background-color: #fff;
            }
        }
    }

    &:before {
        content: "";
        background-color: #003c7b;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.9;
        z-index: -1;
    }

    .cp {
        cursor: pointer;
    }

    .flex {
        display: flex;

        &-center {
            align-items: center;
        }
    }

    .text-upper {
        text-transform: uppercase;
    }

    @media (max-width: 640px) {
        &-body {
            padding-top: 20px;
            padding-bottom: 20px;
            font-size: 1.3rem;
            line-height: 1.7rem;
        }

        &-action {
            text-align: center;
            margin-left: 0;
            padding-bottom: 20px;

            a {
                font-size: 1.3rem;
                line-height: 1.7rem;
                padding: 8px 12px;
            }
        }

        .flex {
            display: block;
        }

        .wrapper {
            padding: 0 10px;
        }
    }
}
</style>
